import { Container, Spinner, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import LoginRequiredNotice from '../components/common/LoginRequiredNotice';
import ZebraPadding from '../components/common/ZebraPadding';
import { ISsoStore } from '../stores/SsoStore';

interface LoginNoticeWrapperProps {
  children: React.ReactNode;
  ssoStore?: ISsoStore;
}

const LoginNoticeWrapper = (props: LoginNoticeWrapperProps): JSX.Element => {
  const { children, ssoStore } = props;

  if (ssoStore.loading) {
    return (
      <ZebraPadding>
        <Container>
          <Spinner />
        </Container>
      </ZebraPadding>
    );
  }
  if (!ssoStore.loading && !ssoStore.customerSelected) {
    return (
      <ZebraPadding>
        <Container>
          <Text>
            <LoginRequiredNotice />
          </Text>
        </Container>
      </ZebraPadding>
    );
  }
  return children as JSX.Element;
};

export default inject('ssoStore', 'translateStore')(observer(LoginNoticeWrapper));
